import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBksYTSZljF29W5GI9X7Vqs0lVqwKb_RP0",
  authDomain: "tugas-akhir-58208.firebaseapp.com",
  projectId: "tugas-akhir-58208",
  storageBucket: "tugas-akhir-58208.appspot.com",
  messagingSenderId: "547542537562",
  appId: "1:547542537562:web:76cba9caa6b77f76074f63"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services with explicit app reference
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Export initialized services
export { auth, db, storage };
export default app;
